import { API_BASE } from "@/lib/api";
import { User as UserIcon } from "lucide-react";

/**
 * Renders a user's avatar with server-issued signed URL.
 * Falls back to first-letter initial.
 * `size` in tailwind size classes, e.g. "w-9 h-9".
 * `refresh` (any changing value) busts the URL cache after upload.
 */
export default function Avatar({ user, size = "w-9 h-9", textClass = "text-sm", refresh }) {
  // Prefer server-signed URL (from list endpoints). Fall back to relative path if only
  // avatar_path is known (e.g. just-uploaded, no fresh list fetch yet).
  let src = user?.avatar_url;
  if (!src && user?.avatar_path && user?.id) {
    src = `${API_BASE}/users/${user.id}/avatar`; // relies on same-origin cookie
  }
  if (src && refresh) {
    src += (src.includes("?") ? "&" : "?") + "v=" + encodeURIComponent(refresh);
  }
  const initial = (user?.name || user?.email || "?").slice(0, 1).toUpperCase();
  return (
    <div className={`${size} rounded-full border border-white/10 bg-[#1A1A1A] overflow-hidden grid place-items-center text-gold font-semibold ${textClass} shrink-0`}>
      {src ? (
        <img
          src={src}
          alt={user?.name || "avatar"}
          className="w-full h-full object-cover"
          onError={(e) => { e.currentTarget.style.display = "none"; }}
        />
      ) : (
        user ? initial : <UserIcon className="w-4 h-4" />
      )}
    </div>
  );
}
